import React from "react";

import { IgTypography } from "@intelligems/ig-theme";
import { useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";

interface SectionHeaderProps {
  title: string;
  drawerOpen: boolean;
}

export const SectionHeader = ({ title, drawerOpen }: SectionHeaderProps) => {
  const theme = useTheme();

  if (!drawerOpen) {
    return null;
  }

  return (
    <Grid
      sx={{
        px: drawerOpen ? 2 : 4,
        paddingTop: 1,
        paddingBottom: 2,
        display: "flex",
        alignItems: "center",
        marginLeft: 2,
        marginTop: 2,
      }}
    >
      <IgTypography variant="body2" color={theme.palette.text.secondary}>
        {title}
      </IgTypography>
    </Grid>
  );
};
